export default __webpack_public_path__ + "static/media/IMG_3533.485c7c61.jpg";